<form [formGroup]="widgetForm">
  <div class="form-content">
    <mat-card>
      <mat-card-header>
        <mat-card-title>{{ 'INBOX.WEBCHAT.SETTINGS.WIDGET_NAME' | translate }}</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <glxy-form-field>
          <input
            matInput
            id="welcome-message"
            id="name"
            formControlName="name"
            [placeholder]="'INBOX.WEBCHAT.SETTINGS.WIDGET_NAME' | translate"
          />
          <glxy-hint>
            {{ 'INBOX.WEBCHAT.SETTINGS.WIDGET_NAME_DESCRIPTION' | translate }}
          </glxy-hint>
        </glxy-form-field>
      </mat-card-content>
    </mat-card>

    <mat-card>
      <mat-card-header>
        <mat-card-title>{{ 'INBOX.WEBCHAT.SETTINGS.WEBCHAT_ASSISTANT_TITLE' | translate }}</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <ai-knowledge-application-knowledge
          *ngIf="manageKnowledgeFeatureEnabled$ | async; else editKnowledge"
          [appId]="knowledgeAppId"
          (selectedSourcesChange)="updateSelectedSources($event)"
        ></ai-knowledge-application-knowledge>
        <ng-template #editKnowledge>
          <ng-container *ngIf="!automatedAssistantSettingsLoading(); else loading">
            <glxy-form-field *ngIf="isBusinessApp" formGroupName="dataSources">
              <mat-checkbox formControlName="businessProfile">
                {{ 'INBOX.WEBCHAT.SETTINGS.BUSINESS_PROFILE.ALLOW_ACCESS' | translate }}
                <extended>
                  <div>
                    {{ 'INBOX.WEBCHAT.SETTINGS.BUSINESS_PROFILE.DESCRIPTION' | translate }}
                    <a (click)="businessProfileLearnMore($event)">{{
                      'INBOX.WEBCHAT.SETTINGS.LEARN_MORE' | translate
                    }}</a>
                  </div>
                </extended>
                <a
                  mat-stroked-button
                  color="secondary"
                  class="manage-business-profile"
                  [routerLink]="businessAppProfileUrl()"
                  target="_blank"
                >
                  {{ 'INBOX.WEBCHAT.SETTINGS.BUSINESS_PROFILE.MANAGE_BUSINESS_PROFILE' | translate }}
                  <mat-icon iconPositionEnd>open_in_new</mat-icon>
                </a>
              </mat-checkbox>
            </glxy-form-field>
            <glxy-form-field formGroupName="dataSources">
              <mat-checkbox formControlName="userInput">
                {{ 'INBOX.WEBCHAT.SETTINGS.CUSTOM_KNOWLEDGE.CUSTOM_KNOWLEDGE' | translate }}
                <extended>
                  <div>
                    {{ 'INBOX.WEBCHAT.SETTINGS.CUSTOM_KNOWLEDGE.DESCRIPTION' | translate }}
                  </div>
                </extended>
              </mat-checkbox>
              <div class="custom-knowledge" *ngIf="widgetForm?.get('dataSources')?.get('userInput').value">
                <glxy-form-field [formGroup]="customKnowledgeForm">
                  <textarea matInput formControlName="content" class="custom-knowledge-content" [rows]="10"></textarea>
                </glxy-form-field>
              </div>
            </glxy-form-field>
          </ng-container>
        </ng-template>
        <ng-template #loading>
          <glxy-loading-spinner *ngIf="automatedAssistantSettingsLoading()"></glxy-loading-spinner>
        </ng-template>
      </mat-card-content>
    </mat-card>

    <mat-card>
      <mat-card-header>
        <mat-card-title>{{ 'INBOX.WEBCHAT.SETTINGS.WEBCHAT_GREETING' | translate }}</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <p>{{ 'INBOX.WEBCHAT.SETTINGS.WEBCHAT_GREETING_DESCRIPTION' | translate }}</p>
        <glxy-form-field>
          <textarea
            matInput
            id="welcome-message"
            formControlName="welcomeMessage"
            [placeholder]="'INBOX.WEBCHAT.SETTINGS.WEBCHAT_GREETING_PLACEHOLDER' | translate"
            maxlength="70"
            #welcomeMessageLimit
          ></textarea>
          <glxy-hint align="right">{{ welcomeMessageLimit.value?.length || 0 }}/70</glxy-hint>
        </glxy-form-field>
      </mat-card-content>
    </mat-card>

    <mat-card>
      <mat-card-header>
        <mat-card-title>{{ 'INBOX.WEBCHAT.SETTINGS.APPEARANCE' | translate }}</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <div class="color-picker-container">
          <glxy-form-field>
            <glxy-label>{{ 'INBOX.WEBCHAT.SETTINGS.PRIMARY_COLOR' | translate }}</glxy-label>
            <input
              matInput
              type="color"
              id="color-picker"
              formControlName="color"
              [value]="widgetForm?.value['color']"
              (change)="setTextColor()"
            />
            <input
              matInput
              id="color"
              formControlName="color"
              placeholder="#555555"
              [value]="widgetForm?.value['color']"
              (change)="setTextColor()"
            />
            <glxy-error *ngIf="widgetForm.get('color').invalid">
              {{ 'INBOX.WEBCHAT.SETTINGS.INVALID_COLOR' | translate }}
            </glxy-error>
          </glxy-form-field>
        </div>
        <glxy-form-field>
          <glxy-label>{{ 'INBOX.WEBCHAT.SETTINGS.TEXT_COLOR' | translate }}</glxy-label>
          <mat-button-toggle-group [formControl]="widgetForm?.controls?.textColor">
            <mat-button-toggle value="dark">
              {{ 'INBOX.WEBCHAT.SETTINGS.DARK' | translate }}
            </mat-button-toggle>
            <mat-button-toggle value="light">
              {{ 'INBOX.WEBCHAT.SETTINGS.LIGHT' | translate }}
            </mat-button-toggle>
          </mat-button-toggle-group>
        </glxy-form-field>

        <div class="color-picker-container">
          <glxy-form-field>
            <glxy-label>{{ 'INBOX.WEBCHAT.SETTINGS.ACCENT_COLOR' | translate }}</glxy-label>
            <input
              matInput
              type="color"
              id="accent-color-picker"
              formControlName="accentColor"
              [value]="widgetForm?.value['accentColor']"
              (change)="setAccentTextColor()"
            />
            <input
              matInput
              id="accentColor"
              formControlName="accentColor"
              placeholder="#555555"
              [value]="widgetForm?.value['accentColor']"
              (change)="setAccentTextColor()"
            />
            <glxy-error *ngIf="widgetForm.get('accentColor').invalid">
              {{ 'INBOX.WEBCHAT.SETTINGS.INVALID_COLOR' | translate }}
            </glxy-error>
          </glxy-form-field>
        </div>
        <glxy-form-field>
          <glxy-label>{{ 'INBOX.WEBCHAT.SETTINGS.ACCENT_TEXT_COLOR' | translate }}</glxy-label>
          <mat-button-toggle-group [formControl]="widgetForm?.controls?.accentTextColor">
            <mat-button-toggle value="dark">
              {{ 'INBOX.WEBCHAT.SETTINGS.DARK' | translate }}
            </mat-button-toggle>
            <mat-button-toggle value="light">
              {{ 'INBOX.WEBCHAT.SETTINGS.LIGHT' | translate }}
            </mat-button-toggle>
          </mat-button-toggle-group>
        </glxy-form-field>
      </mat-card-content>
    </mat-card>
  </div>
</form>
